import { useGetMe } from 'Shared/hooks/api';
import { useTokenStore } from 'Shared/hooks/useTokenStore';
import { Analytics } from 'Shared/utils/client';
import { LINK } from '@constants';
import { Button, Column, Icon, Point, Row, Spinner, Typography } from '@viewup/ui';
import { useGlobalModalStore } from 'app/_hook';
import { useGetDailyCheckInRound } from 'app/stamp/_entities/api/useGetDailyCheckInRound';
import { hasCheckedInToday } from 'app/stamp/_entities/model/dailyCheckIn/roundStatus';
import { useGetEarnedPoints } from 'app/viewing-money/_features/api';
import { useRouter } from 'next/navigation';
import { EmptyViewingMoneyModal } from '../EmptyViewingMoneyModal';
import { ViewupStamp } from '../Main/ViewupStamp';

export const AuthBox = () => {
  const router = useRouter();
  const { accessToken } = useTokenStore();
  const { data, isPending } = useGetMe();
  const me = data?.data;
  const isMePending = !!accessToken && isPending;
  const { data: earnedPoints } = useGetEarnedPoints({ options: { enabled: !!accessToken } });
  const exchangeablePoint = earnedPoints?.data.exchangeablePoint;
  const { getValue } = useGlobalModalStore();
  const { setAlertModal } = getValue('actions');

  const { data: round } = useGetDailyCheckInRound({ options: { enabled: !!accessToken } });
  // 오늘 오전·오후 중 한 번이라도 출석했으면 완료 — CTA 잠금(열린 슬롯 기준)과 다른 하루 단위 판정이다.
  // 회차 응답 전(로딩)이나 오늘을 못 정하면 false 라 미완료 문구로 떨어진다.
  const isAlreadyAttended = hasCheckedInToday(round);

  return (
    <Column gap={24} pb={8} pt={24} px={24}>
      <Row alignItems='flex-start' justifyContent='space-between'>
        <Column gap={8}>
          <Column>
            <Typography fontType='header2.bold'>
              {accessToken ? (
                isMePending ? (
                  <span style={{ display: 'inline-flex' }}>
                    <Spinner size='XS' variant='threeDot' />
                  </span>
                ) : (
                  <>
                    <span>{me?.nickname}</span>님,
                  </>
                )
              ) : (
                '보이는 적립'
              )}
            </Typography>

            <Typography fontType='header2.medium'>
              {accessToken
                ? isAlreadyAttended
                  ? '오늘도 출석 체크 완료!'
                  : '오늘도 출석 완료했나요?'
                : '뷰업을 시작해 볼까요?'}
            </Typography>
          </Column>
        </Column>
        {!accessToken && (
          <Button
            isRound
            onClick={() => router.push(LINK.LOGIN)}
            size={'S'}
            styledComponents={{
              root: {
                bgColor: 'bg.infoSubtle',
              },
            }}
            variant='outline.primary'
          >
            로그인
          </Button>
        )}
      </Row>
      <ViewupStamp />
      {accessToken && (
        <Button
          onClick={() => {
            Analytics.getInstance().track('MAIN_VIEWING_MONEY');
            if (!me) return;
            EmptyViewingMoneyModal(me.totalPoint, router, setAlertModal);
          }}
          size={'L'}
          styledComponents={{
            children: { width: '100%' },
            root: { br: 12, width: '100%' },
          }}
          variant='solid.info'
        >
          <Row alignItems='center' justifyContent='space-between'>
            <Typography color='text.primaryInverse' fontType='body2.regular'>
              지금까지 모은 뷰업 포인트
            </Typography>
            <Row alignItems='center' gap={4}>
              <Icon color='icon.interactive.inverse' source={Point} />
              <Typography color='text.primaryInverse' fontType='header3.bold'>
                {isMePending ? (
                  <InlineSpinner minWidth={48} />
                ) : (
                  exchangeablePoint?.toLocaleString()
                )}
              </Typography>
            </Row>
          </Row>
        </Button>
      )}
    </Column>
  );
};

const InlineSpinner = ({ minWidth }: { minWidth: number }) => {
  return (
    <span style={{ display: 'inline-flex', minWidth }}>
      <Spinner size='S' variant='threeDot' />
    </span>
  );
};
